import React, { useEffect, useState } from 'react'
import { Container, Box, Grid, Typography, Card, CardHeader, CardContent, CardActions, Button } from '@mui/material';
import Swal from 'sweetalert2';
import { message } from 'antd';

// ICONOS MUI
import EventIcon from '@mui/icons-material/Event';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PlaceIcon from '@mui/icons-material/Place';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import EmailIcon from '@mui/icons-material/Email';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import HomeIcon from '@mui/icons-material/Home';
import CheckIcon from '@mui/icons-material/Check';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import BusinessIcon from '@mui/icons-material/Business';
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

function ViewPendingPicturesConfirmation() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [messageApi, contextHolder] = message.useMessage();
  const [confirmingId, setConfirmingId] = useState(null);

  const fetchEvents = async () => {
    try {
      const response = await fetch('https://dprincess-training.servehttp.com/reservations/pending-pictures-confirmation/', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (response.ok) {
        const data = await response.json();
        setEvents(data);
      } else {
        console.error('Error fetching events:', response.statusText);
        messageApi.open({
          type: 'error',
          content: 'Error al obtener las reservaciones pendientes de selección de fotos.',
          duration: 5,
        });
      }
    }
    catch (error) {
      console.error('Error:', error);
      messageApi.open({
        type: 'error',
        content: 'Error al obtener las reservaciones pendientes de selección de fotos.',
        duration: 5,
      });
    } finally {
      setLoading(false);
    }
  }

  const handleConfirmPicturesSelection = async (reservationID) => {
    try {
      const confirmationResponse = await Swal.fire({
        title: 'Confirmar Selección de Fotos',
        text: '¿Estás seguro/a de que deseas confirmar la selección de fotos para esta reservación?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, confirmar',
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
      });
      if (confirmationResponse.isConfirmed) {
        const currentDate = new Date();
        const deliveryDate = new Date(currentDate);
        deliveryDate.setDate(currentDate.getDate() + 15);

        try {
          const response = await fetch(`https://dprincess-training.servehttp.com/reservations/update-pictures-confirmation/${reservationID}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({
              reservationID,
              selectionDate: currentDate.toISOString(),
              deliveryDate: deliveryDate.toISOString(),
              createdAt: currentDate.toISOString(),
              confirmationStatus: 1
            })
          });
          if (response.ok) {
            messageApi.open({
              type: 'success',
              content: 'Se confirmó la selección de fotos de manera exitosa.',
            });
            fetchEvents(); // Refresh the events list after confirmation
          } else {
            console.error('Error confirming pictures selection:', response.statusText);
            messageApi.open({
              type: 'error',
              content: 'Error al confirmar la selección de fotos.',
            });
          }
        } catch (error) {
          console.error('Error:', error);
          messageApi.open({
            type: 'error',
            content: 'Error al procesar la petición para confirmar la selección de fotos.',
          });
        }
      }
      else {
        messageApi.open({
          type: 'info',
          content: 'Confirmación cancelada.',
        });
      }
    } catch (error) {
      console.error('Error:', error);
      messageApi.open({
        type: 'error',
        content: 'Error al confirmar la selección de fotos.',
      });
    }
  }

  useEffect(() => {
    fetchEvents();
  }, []);

  return (
    <Container
      maxWidth="lg"
      sx={{
        minHeight: '100vh',
        py: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%',
        marginTop: '10px',
        marginBottom: '50px',
      }}
    >
      {contextHolder}
      <Box
        sx={{
          mb: 4,
          textAlign: 'center',
          width: '100%',
          background: '#f759ab',
          borderRadius: '24px',
          py: 1,
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          sx={{
            fontWeight: 700,
            color: '#fff',
            letterSpacing: '0.5px',
            fontSize: { xs: '2rem', md: '2.5rem' }
          }}
        >
          Reservaciones pendientes de selección de fotos
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            color: '#fff',
            opacity: 0.8,
            fontWeight: 400,
            fontSize: '1.1rem'
          }}
        >
          Revisa y gestiona las reservaciones que requieren selección de fotos por parte del cliente
        </Typography>
      </Box>
      <Grid
        container
        spacing={3}
        sx={{
          mb: 4,
          justifyContent: 'center',
          width: '100%',
          background: 'linear-gradient(135deg, #f8fafc 0%, #f3e8ff 100%)',
          borderRadius: '24px',
          boxShadow: '0 8px 32px 0 rgba(80,0,120,0.10)',
          marginLeft: 0
        }}
        maxWidth={'lg'}
      >
        {loading ? (
          <Grid item xs={12}>
            <Typography variant="body1" sx={{ color: '#7c3aed', fontWeight: 500 }}>
              Cargando reservaciones...
            </Typography>
          </Grid>
        ) : events.length > 0 ? (
          events.map((event) => (
            <Grid item xs={12} md={10} key={event.id} maxWidth={'md'}>
              <Card
                sx={{
                  mb: 2,
                  borderRadius: '18px',
                  boxShadow: '0 4px 16px 0 rgba(124,58,237,0.10)',
                  border: '1.5px solid #ede9fe',
                  background: 'linear-gradient(90deg, #fff 80%, #f3e8ff 100%)',
                  transition: 'box-shadow 0.2s',
                  '&:hover': {
                    boxShadow: '0 8px 32px 0 rgba(124,58,237,0.18)',
                    borderColor: '#c4b5fd'
                  }
                }}
              >
                <CardHeader
                  title={
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography
                        variant="h6"
                        sx={{
                          color: '#5b21b6',
                          fontWeight: 700,
                          fontSize: '1.25rem',
                          letterSpacing: '0.2px'
                        }}
                      >
                        Reservación: {event.eventTitle}
                      </Typography>
                    </Box>
                  }
                  sx={{ pb: 0, pt: 2, px: 3 }}
                />
                <CardContent sx={{ pt: 1, pb: 2, px: 3 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <EventIcon sx={{ color: '#7c3aed', mr: 1 }} />
                        <Typography variant="body2">
                          Fecha de inicio: <span style={{ color: '#333', fontWeight: 400 }}>{new Date(event.eventDateStart).toLocaleDateString()}</span>
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <AccessTimeIcon sx={{ color: '#f759bb', mr: 1 }} />
                        <Typography variant="body2">
                          Hora de inicio: <span style={{ color: '#333', fontWeight: 400 }}>{new Date(event.eventDateStart).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <PlaceIcon sx={{ color: '#22c55e', mr: 1 }} />
                        <Typography variant="body2">
                          Lugar: <span style={{ color: '#333', fontWeight: 400 }}>{event.eventLocation}</span>
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <EventIcon sx={{ color: '#7c3aed', mr: 1 }} />
                        <Typography variant="body2">
                          Fecha de finalización: <span style={{ color: '#333', fontWeight: 400 }}>{new Date(event.eventDateEnd).toLocaleDateString()}</span>
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <AccessTimeIcon sx={{ color: '#f759bb', mr: 1 }} />
                        <Typography variant="body2">
                          Hora de finalización: <span style={{ color: '#333', fontWeight: 400 }}>{new Date(event.eventDateEnd).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        {
                          event.eventType === 'inside' ? (
                            <BusinessIcon sx={{ color: '#22c55e', mr: 1 }} />
                          ) : (
                            <EmojiTransportationIcon sx={{ color: '#22c55e', mr: 1 }} />
                          )
                        }
                        <Typography variant="body2">
                          Tipo de sesión fotográfica: <span style={{ color: '#333', fontWeight: 400 }}>{event.eventType === 'inside' ? "Estudio" : "Exterior"}</span>
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={12} md={6}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <PersonIcon sx={{ color: '#7c3aed', mr: 1 }} />
                        <Typography variant="body2">
                          Cliente: <span style={{ color: '#333', fontWeight: 400 }}>{event.clientName}</span>
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <PhoneIcon sx={{ color: '#f59e42', mr: 1 }} />
                        <Typography variant="body2">
                          Teléfono: <span style={{ color: '#333', fontWeight: 400 }}>{event.phoneNumber}</span>
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <PlaceIcon sx={{ color: '#22c55e', mr: 1 }} />
                        <Typography variant="body2">
                          Dirección: <span style={{ color: '#333', fontWeight: 400 }}>{event.address}</span>
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <BusinessIcon sx={{ color: '#7c3aed', mr: 1 }} />
                        <Typography variant="body2">
                          Combo: <span style={{ color: '#333', fontWeight: 400 }}>{event.comboName}</span>
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Typography variant="body2" sx={{ color: '#f59e42', mr: 1 }}>
                          💰
                        </Typography>
                        <Typography variant="body2">
                          Precio del combo: <span style={{ color: '#333', fontWeight: 400 }}>${event.comboPrice}</span>
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <SmartphoneIcon sx={{ color: '#f59e42', mr: 1 }} />
                        <Typography variant="body2">
                          Celular: <span style={{ color: '#333', fontWeight: 400 }}>{event.cellphoneNumber}</span>
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <EmailIcon sx={{ color: '#7c3aed', mr: 1 }} />
                        <Typography variant="body2">
                          Correo electrónico: <span style={{ color: '#333', fontWeight: 400 }}>{event.clientEmail}</span>
                        </Typography>
                      </Box>
                      {event.XVName && (
                        <>
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <PersonIcon sx={{ color: '#f59e42', mr: 1 }} />
                            <Typography variant="body2">
                              Nombre de la quinceañera: <span style={{ color: '#333', fontWeight: 400 }}>{event.XVName}</span>
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <SmartphoneIcon sx={{ color: '#f59e42', mr: 1 }} />
                            <Typography variant="body2">
                              Celular de la quinceañera: <span style={{ color: '#333', fontWeight: 400 }}>{event.XVCellphoneNumber}</span>
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <EmailIcon sx={{ color: '#7c3aed', mr: 1 }} />
                            <Typography variant="body2">
                              Correo de la quinceañera: <span style={{ color: '#333', fontWeight: 400 }}>{event.XVEmail}</span>
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <EventIcon sx={{ color: '#7c3aed', mr: 1 }} />
                            <Typography variant="body2">
                              Fecha de cumpleaños: <span style={{ color: '#333', fontWeight: 400 }}>{new Date(event.birthday).toLocaleDateString()}</span>
                            </Typography>
                          </Box>
                        </>
                      )}
                      {event.name && (
                        <>
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <PersonIcon sx={{ color: '#f59e42', mr: 1 }} />
                            <Typography variant="body2">
                              Nombre de la pareja: <span style={{ color: '#333', fontWeight: 400 }}>{event.name}</span>
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <SmartphoneIcon sx={{ color: '#f59e42', mr: 1 }} />
                            <Typography variant="body2">
                              Celular de la pareja: <span style={{ color: '#333', fontWeight: 400 }}>{event.wpCellphoneNumber}</span>
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <EmailIcon sx={{ color: '#7c3aed', mr: 1 }} />
                            <Typography variant="body2">
                              Correo de la pareja: <span style={{ color: '#333', fontWeight: 400 }}>{event.wpEmail}</span>
                            </Typography>
                          </Box>
                        </>
                      )}
                      {event.birthdayDudeName && (
                        <>
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <PersonIcon sx={{ color: '#f59e42', mr: 1 }} />
                            <Typography variant="body2">
                              Nombre del cumpleañero: <span style={{ color: '#333', fontWeight: 400 }}>{event.birthdayDudeName}</span>
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <SmartphoneIcon sx={{ color: '#f59e42', mr: 1 }} />
                            <Typography variant="body2">
                              Celular del cumpleañero: <span style={{ color: '#333', fontWeight: 400 }}>{event.birthdayDudeCellphoneNumber}</span>
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <EmailIcon sx={{ color: '#7c3aed', mr: 1 }} />
                            <Typography variant="body2">
                              Correo del cumpleañero: <span style={{ color: '#333', fontWeight: 400 }}>{event.birthdayDudeEmail}</span>
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <EventIcon sx={{ color: '#7c3aed', mr: 1 }} />
                            <Typography variant="body2">
                              Fecha de cumpleaños: <span style={{ color: '#333', fontWeight: 400 }}>{new Date(event.birthdayDudeBirthday).toLocaleDateString()}</span>
                            </Typography>
                          </Box>
                        </>
                      )}
                    </Grid>
                  </Grid>
                </CardContent>
                <CardActions sx={{ justifyContent: 'flex-end', px: 3, pb: 2 }}>
                  <Button
                    variant="contained"
                    startIcon={<CheckIcon />}
                    onClick={() => handleConfirmPicturesSelection(event.reservationID)}
                    sx={{
                      backgroundColor: '#5b21b6',
                      color: '#fff',
                      '&:hover': {
                        backgroundColor: '#4c1d95'
                      }
                    }}
                  >
                    Confirmar selección de fotos
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))
        ) : (
          <Grid item xs={12} sx={{ textAlign: 'center', py: 6 }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                backgroundColor: 'rgba(243, 232, 255, 0.6)',
                borderRadius: '16px',
                p: 4,
                maxWidth: '500px',
                mx: 'auto',
                border: '1px dashed #c4b5fd'
              }}
            >
              <TaskAltIcon
                sx={{
                  fontSize: 64,
                  color: '#9333ea',
                  mb: 2,
                  opacity: 0.9
                }}
              />
              <Typography
                variant="h5"
                sx={{
                  color: '#5b21b6',
                  fontWeight: 600,
                  mb: 1
                }}
              >
                ¡Todo al día!
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: '#7c3aed',
                  mb: 2,
                  textAlign: 'center'
                }}
              >
                No hay reservaciones pendientes de selección de fotos en este momento.
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: '#8b5cf6',
                  opacity: 0.8,
                  maxWidth: '360px',
                  textAlign: 'center'
                }}
              >
                Los reservaciones que requieran selección de fotos aparecerán aquí cuando estén disponibles.
              </Typography>
            </Box>
          </Grid>
        )}
      </Grid>
      <Box
        sx={{
          mt: 4,
          mb: 4,
          width: '100%',
          background: '#f3e8ff',
          borderRadius: '14px',
          p: 3,
          boxShadow: '0 2px 8px 0 rgba(124,58,237,0.07)',
        }}
      >
        <Typography
          variant="h6"
          component="h2"
          gutterBottom
          sx={{
            color: '#5b21b6',
            fontWeight: 700,
            fontSize: '1.15rem'
          }}
        >
          Notas sobre selección de fotos:
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          - Las reservaciones pendientes de selección de fotos son aquellas que requieren que el cliente elija las fotos del evento.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          - Para confirmar la selección de fotos, haz clic en el botón correspondiente y se programará la entrega en 15 días.
        </Typography>
      </Box>
    </Container>
  )
}

export default ViewPendingPicturesConfirmation